<article [class]="'list-layout ' + class">
  <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
  @if (successMessage && !hideNotifications) {
    <ftr-notification [type]="notificationType.Success">{{ successMessage }}</ftr-notification>
  }
  @if (errorMessage && !hideNotifications) {
    <ftr-notification [type]="notificationType.Error">{{ errorMessage }}</ftr-notification>
  }
  @if (!hideNotifications) {
    <ftr-notification-flash></ftr-notification-flash>
  }
  <ftr-animated-remote
    [remote]="entities"
    [loadingTemplate]="loading"
    [failureTemplate]="failure"
    [successTemplate]="success"
    [emptyTemplate]="empty"
    [isEmpty]="isEmpty"
  >
    <ng-template #loading>
      @if (loadingTemplate) {
        <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
      }
      @if (!loadingTemplate) {
        <ftr-line-loader [isLoading]="true" [message]="'Loading ' + plural" [fullPage]="true"></ftr-line-loader>
      }
    </ng-template>

    <ng-template #failure>
      <section class="card-list card-list__error list-layout__list">
        <ng-container *ngTemplateOutlet="listHeaderTemplate"></ng-container>
        <div [ngClass]="{ 'card media': useCards }">
          @if (errorTemplate) {
            <ng-container *ngTemplateOutlet="errorTemplate"></ng-container>
          }
          @if (!errorTemplate) {
            <ftr-error-retry [text]="'Failed to retrieve ' + plural" (retry)="retry()"></ftr-error-retry>
          }
        </div>
      </section>
    </ng-template>

    <ng-template #empty>
      <section class="card-list card-list__empty list-layout__list">
        @if (filterTemplate) {
          <ng-container
            class="paginated-list__filter"
            *ngTemplateOutlet="filterTemplate; context: { $implicit: [] }"
          ></ng-container>
        }
        <ng-container *ngTemplateOutlet="listHeaderTemplate"></ng-container>
        <div [ngClass]="{ 'card media': useCards }">
          @if (emptyListTemplate) {
            <ng-container *ngTemplateOutlet="emptyListTemplate"></ng-container>
          }
          @if (!emptyListTemplate) {
            <p>You have no {{ currentFilter }} {{ plural }} yet.</p>
          }
          @if (icon) {
            <ftr-icon [icon]="icon" size="Max" color="GreyLighter"></ftr-icon>
          }
        </div>
      </section>
    </ng-template>
    <ng-template #success let-data>
      <div class="paginated-list" role="list">
        <div class="paginated-list__top">
          <div>
            @if (filterTemplate) {
              <ng-container
                class="paginated-list__filter"
                *ngTemplateOutlet="filterTemplate; context: { $implicit: data.items }"
              ></ng-container>
            }
          </div>
          @if (meta) {
            <ftr-pagination
              class="paginator"
              [meta]="meta!"
              paginationType="top"
              [ngClass]="{ 'paginated-list--hide-paginator': hideTopPaginator }"
            >
            </ftr-pagination>
          }
        </div>
        <section class="card-list">
          <ng-container *ngTemplateOutlet="listHeaderTemplate; context: { $implicit: data.items }"></ng-container>
          <ng-container *ngTemplateOutlet="listTemplate; context: { $implicit: data.items }"></ng-container>
          @if (meta) {
            <ftr-pagination
              class="paginator"
              [ngClass]="{ 'paginated-list--hide-paginator': hideBottomPaginator }"
              [meta]="meta!"
              paginationType="bottom"
            >
            </ftr-pagination>
          }
        </section>
      </div>
    </ng-template>
  </ftr-animated-remote>
</article>
